<template>
  <section class="flex w-[220px] flex-col items-start gap-1 self-stretch">
    <div
      v-for="type in filteredShareTypes"
      :key="type.id"
      class="flex cursor-pointer items-center gap-2 self-stretch rounded-md px-3 py-2"
      :class="[activeShareType === type.id ? 'active-bg' : '']"
      @click="onShareListClick(type.id)"
    >
      <UITextSmMedium :class="[activeShareType === type.id ? 'text-primary-700' : '']">
        {{ type.name }}
      </UITextSmMedium>
    </div>
  </section>
</template>

<script setup lang="ts">
import { UITextSmMedium } from "@gohighlevel/ghl-ui";
import { computed, ref } from "vue";
import { useAppStore } from "../../../store/app";
import { SHARE_TYPE, SHARE_TYPE_LIST } from "../../../util/constants";

const store = useAppStore();
const emits = defineEmits(["shareType:change"]);

const activeShareType = ref(1);

const filteredShareTypes = computed(() => {
  return SHARE_TYPE_LIST.filter((type) => type.id !== SHARE_TYPE.EMAIL || store.formId);
});

const onShareListClick = (id) => {
  activeShareType.value = id;
  emits("shareType:change", id);
};
</script>

<style scoped>
.active-bg {
  background: #eff4ff;
}
</style>
